import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'randomText' })
export class RandomTextPipe implements PipeTransform {

  constructor() {}

  transform(value: any, active: boolean): any {
    if (active) {
      const characters = 'abcdefghijklmnopqrstuvwxyz';
      const minLength = 5;
      const maxLength = 12;
      const length = Math.floor(Math.random() * (maxLength - minLength + 1)) + minLength;
      let result = '';
      for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex];
      }
      return result;
    } else {
      return value
    }
  }
}
